"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import classNames from "classnames";
import reactUtils from "../react_utils";
import pageHelper from "../helpers/document_pages";
import Account from "../api/account";
import Auth from "../util/auth";
import { title } from "../formatters/documents";
var bem = reactUtils.makeBem("document-thumbnail");
function hasGroupingErrors(props) {
  var _a;
  return (((_a = props.document.data) == null ? void 0 : _a["grouping_errors"]) || []).length > 0;
}
function pages(props) {
  if (props.firstPageOnly) {
    return [firstPage(props)];
  }
  return props.document.pages;
}
function firstPage(props) {
  return _.first(props.document.pages);
}
function lazyLoadEnabled() {
  return typeof IntersectionObserver !== "undefined" && !!Account.lazyLoadIndexerThumbnails();
}
function isPageVisible(state, page) {
  if (!lazyLoadEnabled()) {
    return true;
  }
  return state.visiblePageIds.indexOf(page.id) !== -1;
}
function documentPage(props, page, index, visible) {
  var classForPageContainer = bem("__page-container");
  var classesForLabelContainer = [
    bem("__page-label-container"),
    "enable_shared-ui-v3"
  ];
  return /* @__PURE__ */ React.createElement("div", { key: "document-page-" + index, className: classForPageContainer }, /* @__PURE__ */ React.createElement(
    "img",
    {
      className: classForPage(props, page),
      "data-page-id": page.id,
      src: visible ? pageHelper.thumbnail(page) : void 0,
      crossOrigin: "anonymous",
      onContextMenu: (event) => contextMenu(props, page, event),
      onClick: (event) => pageSelected(props, page, event)
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(classesForLabelContainer),
      onClick: (event) => pageSelected(props, page, event)
    },
    /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, labelsForPage(props, page, index))
  ));
}
function labelsForPage(props, page, index) {
  const divClasses = [bem("__page-label"), "v3__descriptor-tag"];
  const labelDivs = [];
  const showOsd = Account.currentSettings().run_no_documents_have_damages_rule;
  if (showOsd && props.document.has_damage && index == 0) {
    const osdClasses = [...divClasses, "v3__descriptor-tag--color-alert"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "osd" }, /* @__PURE__ */ React.createElement("div", { className: classNames(osdClasses) }, "OS&D"))
    );
  }
  const showCarrierRate = Account.currentSettings().run_no_documents_have_carrier_rates_rule;
  if (showCarrierRate && props.document.has_carrier_rate && index == 0) {
    const carrierRateClasses = [
      ...divClasses,
      "v3__descriptor-tag--color-alert"
    ];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "carrier-rate" }, /* @__PURE__ */ React.createElement("div", { className: classNames(carrierRateClasses) }, "Carrier Rate"))
    );
  }
  if (props.isPodForLoad && index == 0) {
    const podClasses = [...divClasses, "v3__descriptor-tag--color-success"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "pod" }, /* @__PURE__ */ React.createElement("div", { className: classNames(podClasses) }, "POD"))
    );
  } else if (props.document.has_missing_pages && index == 0) {
    const missingPagesClasses = [
      ...divClasses,
      "v3__descriptor-tag--color-alert"
    ];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "missing-pages" }, /* @__PURE__ */ React.createElement("div", { className: classNames(missingPagesClasses) }, "Missing Pages"))
    );
  }
  if (props.document.is_signed && index == 0) {
    const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-info"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "signed" }, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Signed"))
    );
  }
  if (props.missingReferenceMatch && index == 0) {
    const missingRefClasses = [
      ...divClasses,
      "v3__descriptor-tag--color-alert"
    ];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "missing-ref" }, /* @__PURE__ */ React.createElement("div", { className: classNames(missingRefClasses) }, "Missing Ref #"))
    );
  }
  if (props.hasReferenceMatch && index == 0) {
    const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-info"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "ref" }, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Ref #"))
    );
  }
  if (props.document.hidden && index == 0) {
    const hiddenClasses = [...divClasses, "v3__descriptor-tag--color-alert"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "hidden" }, /* @__PURE__ */ React.createElement("div", { className: classNames(hiddenClasses) }, "Hidden"))
    );
  }
  if (page.illegible) {
    const illegibleClasses = [...divClasses, "v3__descriptor-tag--color-alert"];
    labelDivs.push(
      /* @__PURE__ */ React.createElement("div", { key: "illegible" }, /* @__PURE__ */ React.createElement("div", { className: classNames(illegibleClasses) }, "Illegible"))
    );
  }
  return labelDivs;
}
function selectedPages(props) {
  return props.selectedPages;
}
function pageIsSelected(props, page) {
  return !_.isEmpty(_.findWhere(selectedPages(props), { id: page.id }));
}
function pageSelected(props, page, event) {
  if (event.shiftKey) {
    props.pageSelected(page, { action: "add" });
  } else {
    props.pageSelected(page, { action: "replace" });
  }
}
function contextMenu(props, page, event) {
  if (props.onContextMenu) {
    event.preventDefault();
    props.onContextMenu(page);
  }
}
function hotkeyTooltipHint(props) {
  if (!props.isDocumentGrouper) {
    return "Go to next page - PgDn or Alt+P\nGo to previous page- PgUp or Alt+Shift+P";
  }
}
function classForPages(props) {
  return bem({
    __pages: true,
    "__pages--group-editor-window": props.variant === "--horizontal"
  });
}
function classForPage(props, page) {
  return bem({
    __page: true,
    "__page--selected": pageIsSelected(props, page)
  });
}
function classForTitle(props) {
  return bem({
    __title: true,
    "__grouping-error-title": hasGroupingErrors(props),
    "__title--group-editor-window": props.variant === "--horizontal"
  });
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { visiblePageIds: [] });
    __publicField(this, "_thumbnailObserver");
    __publicField(this, "observeHiddenThumbnails", () => {
      if (!lazyLoadEnabled()) {
        return;
      }
      const node = ReactDOM.findDOMNode(this);
      if (!node) {
        return;
      }
      if (!this._thumbnailObserver) {
        this._thumbnailObserver = new IntersectionObserver((entries) => {
          const newlyVisible = entries.filter((entry) => entry.isIntersecting).map((entry) => Number(entry.target.getAttribute("data-page-id")));
          if (newlyVisible.length > 0) {
            this.setState({
              visiblePageIds: this.state.visiblePageIds.concat(newlyVisible)
            });
          }
        });
      }
      const observer = this._thumbnailObserver;
      Array.prototype.slice.call(node.querySelectorAll("img:not([src])")).forEach((img) => observer.observe(img));
    });
  }
  render() {
    var hash = {};
    hash[bem()] = true;
    var classes = classNames(hash);
    var maxTitleWidth = 120 * this.props.document.pages.length;
    const hideTitle = !this.props.isDocumentGrouper && Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled;
    const title_ = hideTitle ? "" : title(this.props.document);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes,
        title: hotkeyTooltipHint(this.props),
        "data-document-id": this.props.document.id
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classForTitle(this.props),
          style: { maxWidth: maxTitleWidth },
          onClick: (event) => pageSelected(this.props, firstPage(this.props), event),
          onContextMenu: (event) => contextMenu(this.props, firstPage(this.props), event)
        },
        title_
      ),
      /* @__PURE__ */ React.createElement("div", { className: classForPages(this.props) }, _.map(
        pages(this.props),
        (page, index) => documentPage(
          this.props,
          page,
          index,
          isPageVisible(this.state, page)
        )
      ))
    );
  }
  componentDidMount() {
    this.observeHiddenThumbnails();
  }
  componentDidUpdate() {
    this.observeHiddenThumbnails();
  }
  componentWillUnmount() {
    if (this._thumbnailObserver) {
      this._thumbnailObserver.disconnect();
    }
  }
}
